// extracted by mini-css-extract-plugin
module.exports = {"page":"pdfRenderer_page__3h3RS"};